import React, { useState } from "react"
import { Marker, InfoWindow } from "@react-google-maps/api"
import { LatLng } from "utils/custom.types"

interface MarkersPreviewProps {
  list: any[]
  getPosition: (data: any) => LatLng
  getTitle: (data: any) => string
  getLabel: (data: any, index: number) => string
  children: (data: any) => Element | null
  renderIcon?: (data: any) => null
}
const MarkersPreview = ({
  list,
  getPosition,
  getTitle,
  getLabel,
  renderIcon,
  children,
}: MarkersPreviewProps) => {
  const [hoveredMarker, setHovered] = useState<any>(null)
  return (
    <>
      {list?.map((item, idx) => {
        return (
          <Marker
            icon={renderIcon?.(item)}
            key={item?.id ?? `marker-${idx}`}
            position={getPosition(item)}
            title={getTitle(item)}
            label={getLabel(item, idx)}
            onMouseOver={_e => {
              setHovered(item)
            }}
            onMouseOut={_e => {
              setHovered(null)
            }}
          />
        )
      })}
      {hoveredMarker && (
        <InfoWindow
          options={{
            pixelOffset: new window.google.maps.Size(0, -40),
          }}
          position={getPosition(hoveredMarker)}
          onCloseClick={() => {
            return setHovered(false)
          }}
        >
          <div>{children(hoveredMarker)}</div>
        </InfoWindow>
      )}
    </>
  )
}

MarkersPreview.defaultProps = {
  getTitle: data => data?.name,
  getLabel: (_, idx) => (idx + 1).toString(),
}
export default MarkersPreview
